import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

/* tslint:disable:no-any */
import { setContext } from 'apollo-link-context';
export var createAuthorizationLink = function createAuthorizationLink(dependencies) {
  return setContext( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
      var headers, _yield$dependencies$s, accessToken;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              headers = _ref.headers;
              _context.next = 3;
              return dependencies['session-manager'].getState();

            case 3:
              _yield$dependencies$s = _context.sent;
              accessToken = _yield$dependencies$s.accessToken;
              return _context.abrupt("return", {
                headers: _Object$assign({}, headers, accessToken != null ? {
                  Authorization: "Bearer ".concat(accessToken)
                } : {})
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jcmVhdGVBdXRob3JpemF0aW9uTGluay50cyJdLCJuYW1lcyI6WyJzZXRDb250ZXh0IiwiY3JlYXRlQXV0aG9yaXphdGlvbkxpbmsiLCJkZXBlbmRlbmNpZXMiLCJfIiwiaGVhZGVycyIsImdldFN0YXRlIiwiYWNjZXNzVG9rZW4iLCJBdXRob3JpemF0aW9uIl0sIm1hcHBpbmdzIjoiOzs7O0FBQUE7QUFFQSxTQUFTQSxVQUFULFFBQTJCLHFCQUEzQjtBQUdBLE9BQU8sSUFBTUMsdUJBQXVCLEdBQUcsU0FBMUJBLHVCQUEwQixDQUFDQyxZQUFEO0FBQUEsU0FDckNGLFVBQVU7QUFBQSx5RUFBQyxpQkFBT0csQ0FBUDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQVlDLGNBQUFBLE9BQVosUUFBWUEsT0FBWjtBQUFBO0FBQUEscUJBQ3FCRixZQUFZLENBQUMsaUJBQUQsQ0FBWixDQUFnQ0csUUFBaEMsRUFEckI7O0FBQUE7QUFBQTtBQUNEQyxjQUFBQSxXQURDLHlCQUNEQSxXQURDO0FBQUEsK0NBR0Y7QUFDTEYsZ0JBQUFBLE9BQU8scUJBQ0ZBLE9BREUsRUFFREUsV0FBVyxJQUFJLElBQWYsR0FBc0I7QUFBRUMsa0JBQUFBLGFBQWEsbUJBQVlELFdBQVo7QUFBZixpQkFBdEIsR0FBbUUsRUFGbEU7QUFERixlQUhFOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBQUQ7O0FBQUE7QUFBQTtBQUFBO0FBQUEsTUFEMkI7QUFBQSxDQUFoQyIsInNvdXJjZXNDb250ZW50IjpbIi8qIHRzbGludDpkaXNhYmxlOm5vLWFueSAqL1xuaW1wb3J0IHR5cGUgeyBBcG9sbG9MaW5rIH0gZnJvbSAnYXBvbGxvLWxpbmsnO1xuaW1wb3J0IHsgc2V0Q29udGV4dCB9IGZyb20gJ2Fwb2xsby1saW5rLWNvbnRleHQnO1xuaW1wb3J0IHsgR3JhcGhRTENsaWVudERlcGVuZGVuY2llcyB9IGZyb20gJy4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgY3JlYXRlQXV0aG9yaXphdGlvbkxpbmsgPSAoZGVwZW5kZW5jaWVzOiBHcmFwaFFMQ2xpZW50RGVwZW5kZW5jaWVzKTogQXBvbGxvTGluayA9PlxuICBzZXRDb250ZXh0KGFzeW5jIChfLCB7IGhlYWRlcnMgfTogeyBba2V5OiBzdHJpbmddOiBhbnkgfSkgPT4ge1xuICAgIGNvbnN0IHsgYWNjZXNzVG9rZW4gfSA9IGF3YWl0IGRlcGVuZGVuY2llc1snc2Vzc2lvbi1tYW5hZ2VyJ10uZ2V0U3RhdGUoKTtcblxuICAgIHJldHVybiB7XG4gICAgICBoZWFkZXJzOiB7XG4gICAgICAgIC4uLmhlYWRlcnMsXG4gICAgICAgIC4uLihhY2Nlc3NUb2tlbiAhPSBudWxsID8geyBBdXRob3JpemF0aW9uOiBgQmVhcmVyICR7YWNjZXNzVG9rZW59YCB9IDoge30pLFxuICAgICAgfSxcbiAgICB9O1xuICB9KTtcbiJdfQ==